import React from "react";
import { Icon, IconProps } from "./Icon";
import { IconNamesType, IconType } from "./Icon.types";

export const getIconComponent = (icon: IconType) => {
  if (React.isValidElement(icon)) {
    return icon
  }
  if (typeof icon === "string") {
    return <Icon name={icon as IconNamesType} />
  }
  return <Icon {...icon as IconProps} />
}